import { CircularProgress } from "@mui/material";
import { lazy, Suspense } from "react";

const FindCases = lazy(
  async () =>
    await import("./FindCases").then(async (module) => {
      return {
        default: module.FindCases,
      };
    })
);

/** This is a temporary component with a fully mocked server, until the actual BE is ready. */
export function TemporaryFindCasesWithMockServer() {
  return (
    <Suspense fallback={<CircularProgress />}>
      <FindCases />
    </Suspense>
  );
}
